'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  HomeIcon,
  CalendarDaysIcon,
  MapIcon,
  SparklesIcon,
  StarIcon,
  ChatBubbleLeftRightIcon,
  GiftIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  CalendarDaysIcon as CalendarSolid,
  MapIcon as MapSolid,
  SparklesIcon as SparklesSolid,
  StarIcon as StarSolid,
  ChatBubbleLeftRightIcon as ChatSolid,
  GiftIcon as GiftSolid,
} from '@heroicons/react/24/solid';

const navItems = [
  { label: 'Home', href: '/', OutlineIcon: HomeIcon, SolidIcon: HomeIconSolid, key: 'nav-home' },
  { label: 'Schedule', href: '/schedule-screen', OutlineIcon: CalendarDaysIcon, SolidIcon: CalendarSolid, key: 'nav-schedule' },
  { label: 'Map', href: '/site-map-screen', OutlineIcon: MapIcon, SolidIcon: MapSolid, key: 'nav-sitemap' },
  { label: 'Activities', href: '/activities-food-screen', OutlineIcon: SparklesIcon, SolidIcon: SparklesSolid, key: 'nav-activities' },
  { label: 'Raffle', href: '/raffle-prizes-screen', OutlineIcon: GiftIcon, SolidIcon: GiftSolid, key: 'nav-raffle' },
  { label: 'Sponsors', href: '/sponsors-screen', OutlineIcon: StarIcon, SolidIcon: StarSolid, key: 'nav-sponsors' },
  { label: 'Feedback', href: '/feedback-screen', OutlineIcon: ChatBubbleLeftRightIcon, SolidIcon: ChatSolid, key: 'nav-feedback' },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/20"
      style={{ height: 'var(--nav-height)', paddingBottom: 'env(safe-area-inset-bottom)', backgroundColor: '#0B1437' }}
      aria-label="Main navigation"
    >
      <div className="flex items-stretch h-full max-w-lg mx-auto">
        {navItems?.map((item) => {
          const isActive = pathname === item?.href;
          const IconComponent = isActive ? item?.SolidIcon : item?.OutlineIcon;
          return (
            <Link
              key={item?.key}
              href={item?.href}
              className={`flex flex-col items-center justify-center flex-1 gap-0.5 transition-all duration-200 px-1 relative ${
                isActive
                  ? 'text-yellow-400' : 'text-white/60 hover:text-white/90'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-yellow-400 rounded-b-full" />
              )}
              <IconComponent
                className={`transition-all duration-200 shrink-0 ${isActive ? 'w-6 h-6' : 'w-5 h-5'}`}
              />
              <span
                className={`text-[9px] font-semibold tracking-wide transition-all duration-200 leading-tight text-center w-full truncate ${
                  isActive ? 'text-yellow-400' : 'text-white/60'
                }`}
              >
                {item?.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}